export default {
  computed: {
    $user () {
      return this.$page.props.auth.user
    },
    $breakpoint () {
      return this.$vuetify.display
    },
    $can () {
      return this.$page.props.can
    },
    systemSettings () {
      return this.$page.props['system-settings']
    },
    $months () {
      return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    },
  },
}
